<template>
    <nav aria-label="Page navigation" class="text-center hidden-xs hidden-sm hidden-md">
    <div class="perpage-selector">
      <p class="text-regular">Itens por página: </p>
      <select class="form-control" @change="changedPerPage" @click="trackPerPage">
        <option v-for="(n,index) in [10, 20, 50, 100]"
        :key="index" :selected="n == perPage ? 'selected' : ''">{{ n }}</option>
      </select>
    </div>
    <ul class="pagination" v-if="this.pages.length">
        <li :class="{disabled:page==0}">
          <a  @click="goBack()" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li :class="{active:page==index}" :key="index"
          v-for="(item, index) in pages">
          <a class="text-regular" @click="getPagedCollection(index)">
            {{ index+1 }}
          </a>
        </li>
        <li :class="{disabled:page==pages.length-1}">
          <a @click="goNext()" aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    collection: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      perPage: parseInt(window.localStorage.tableViewPerPage, 10) || 10,
      page: 0,
      pages: [],
      pagedCollection: [],
    };
  },
  methods: {
    getPagedCollection(n) {
      if (n < 0) return;
      this.page = n;
      this.pages = new Array(Math.ceil(this.collection.length / this.perPage));
      const offset = this.page * this.perPage;
      // eslint-disable-next-line vue/no-unused-vars
      // eslint-disable-next-line no-unused-vars
      this.pagedCollection = this.collection.filter((item, index) => {
        if ((index >= offset) && (index < offset + this.perPage)) {
          return true;
        }
        return false;
      });

      this.$emit('changedPage', this.pagedCollection);
    },

    goBack() {
      if (this.page > 0) {
        this.getPagedCollection(this.page -= 1);
      }
    },

    goNext() {
      if (this.page < this.pages.length - 1) {
        this.getPagedCollection(this.page += 1);
      }
      //  tracking.trackGA('Clicou-Tabela','próxima-página')
    },

    trackPerPage() {
      //  tracking.trackGA('Clicou-Tabela','Itens-página');
    },

    changedPerPage(e) {
      this.perPage = parseInt(e.target.value, 10);
      window.localStorage.tableViewPerPage = parseInt(e.target.value, 10);
      this.getPagedCollection(0);
    },
  },
  mounted() {
    this.getPagedCollection(0);
  },

  watch: {
    collection() {
      this.getPagedCollection(0);
    },
  },
};
</script>

<style lang="scss" scoped>

nav{
  display: table;
  width: auto;
  margin: 0 auto;
  padding-bottom: 15px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.perpage-selector{
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  @media (max-width: 768px) {
    padding-bottom: 20px;
  }
}

p{
  display: inline;
  text-align: center;
}

select{
  width: auto;
  display: inline-block;
}

.pagination {
  display: flex;
  text-align: center;
  padding-left: 30px;
  font-size: 14px;
  margin: 0;

  li{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 5px;
    padding: 0 8px;
      height: 28px;

    &.active{
      border: 1px solid #888;
    }

    a{
      span{
        font-size: 20px;
      }
    }
  }
}

</style>
